import {CoreMenu} from '@core/types';
import {Role} from '../core/helpers/constants';


export const menu: CoreMenu[] = [
  {
    id: 'home',
    title: 'Dashboard',
    translate: 'MENU.HOME',
    type: 'item',
    icon: 'home',
    url: 'home',
    showIf: 'always'
  },
  {
    id: 'flexible-benefits',
    title: 'Beneficii Flexibile',
    translate: 'MENU.FLEXIBLE_BENEFITS',
    type: 'item',
    icon: 'grid',
    url: 'flexible-benefits',
    showIf: 'flexible_FLEX'
  },
  {
    id: 'flexible-benefits',
    title: 'Vouchere',
    translate: 'MENU.VOUCHERS_LITE_PLAN',
    type: 'item',
    icon: 'grid',
    url: 'flexible-benefits',
    showIf: 'flexible_LITE'
  },
  {
    id: 'deals',
    title: 'Reduceri',
    translate: 'MENU.DEALS',
    type: 'item',
    icon: 'percent',
    url: '/deals',
    showIf: 'cashback'
  },
  {
    id: 'fixed-benefits',
    title: 'Beneficii Fixe',
    translate: 'MENU.FIXED_BENEFITS',
    type: 'item',
    icon: 'briefcase',
    url: 'fixed-benefits',
    showIf: 'fixed'
  },
  {
    id: 'benefits-history',
    title: 'Istoric Comenzi',
    translate: 'MENU.BENEFITS_HISTORY',
    type: 'item',
    icon: 'clock',
    url: 'benefits-history',
    showIf: 'flexible'
  },
  {
    id: 'admin',
    title: 'Admin',
    translate: 'MENU.ADMIN',
    type: 'item',
    icon: 'pie-chart',
    url: 'admin',
    role: [Role.HR, Role.ADMIN],
    showIf: 'admin'
  },
];
